/* eslint-disable no-console */
/* eslint-disable dot-notation */
/* eslint-disable import/prefer-default-export */
import React, { memo, useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  Col,
} from 'reactstrap';
import { changeAction } from '../../../../../../../actions/BoxSessionLogging';
import { updateEpikBox, updateSipPri } from '../../../../../../../actions/EpikBoxes';
import { clearAddress, getAddress, updateAddress } from '../../../../../../../actions/Provisioning';
import utils from '../../../../../../../lib/utils';
import Location from '../../../../../../../components/Location/index';

export const E911AddressModal = memo(
  ({ isOpen, onCancel, numberId, numberTitle, isTypeSip, settings }) => {
    // const data = useSelector(state => state.AppState.provisioning.address);
    const box = useSelector(state => state.AppState.boxDetails.box);

    const [state, setState] = useState({});
    const [locationState, setLocationState] = useState({});
    // const [trigger, setTrigger] = useState(true);
    const dispatch = useDispatch();
    const getAddress_ = (token, numId) => dispatch(getAddress(token, numId));
    const updateAddress_ = (token, numId, body) => dispatch(updateAddress(token, numId, body));
    const updateBox_ = (token, box_) => dispatch(updateEpikBox(token, box_));
    const changeAction_ = description => dispatch(changeAction(description));
    const updateSipPriSettings = (token, boxId, isPri, settings_) =>
      dispatch(updateSipPri(token, boxId, isPri, settings_));

    const clearAddress_ = () => dispatch(clearAddress());

    const skipRender = useRef(false);
    const token = utils.getAuthToken();

    const fetchAddress = async () => {
      const data = await getAddress_(token, numberId);
      setState(data);
    };

    useEffect(() => {
      if (!skipRender.current) {
        fetchAddress();
      }
    }, []);

    const handleChange = e => {
      setState({ ...state, [e.currentTarget.name]: e.currentTarget.value });
    };

    const onUpdate = async addressObjectWithNumber => {
      await updateAddress_(token, numberId, addressObjectWithNumber);
      const isPri_ = !isTypeSip;
      const shippedAddress_ = {
        street1: state.address1,
        street2: state.address2,
        attn: state.callername,
        city: state.city,
        state: state.state,
        zip: state.zip,
      };
      const updatedSettings = { ...settings };
      updatedSettings.e911Number = numberTitle;
      updatedSettings.shippedAddress = { ...shippedAddress_ };
      await updateSipPriSettings(token, box?._id, isPri_, updatedSettings);
      onCancel();
      await clearAddress_();
    };

    const handleClick = async () => {
      const obj = { ...state, ...locationState };
      obj['dn'] = numberTitle;
      await onUpdate(obj);
    };

    const getLocationInfo = ev => {
      if (ev) {
        setLocationState({
          street1: ev?.address1 || ev?.address,
          street2: ev?.address2,
          address: ev?.address1 || ev?.address,
          address1: ev?.address1 || ev?.address,
          address2: ev?.address2,
          city: ev?.city,
          state: ev?.state,
          zip: ev?.zip,
          country: ev?.country,
        });
      }
    };

    return (
      <Modal isOpen={isOpen}>
        <ModalHeader>{numberTitle}</ModalHeader>
        <ModalBody>
          <FormGroup row>
            <Label for="callername" sm={4}>
              Caller Name:
            </Label>
            <Col sm={12}>
              <Input
                required
                type="text"
                name="callername"
                placeholder="Caller Name..."
                value={state?.callername}
                onChange={handleChange}
              />
            </Col>
          </FormGroup>
          <Location
            disabled={false}
            boxDbLocation={state}
            getLocationInfo={getLocationInfo}
            latLang={false}
            address2={true}
          />
        </ModalBody>
        <ModalFooter>
          <Button outline color="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button color="primary" onClick={handleClick}>
            Update
          </Button>
        </ModalFooter>
      </Modal>
    );
  },
);
